/**
 * @author liuzy 2018-09-05 
 * public目录下方法为PC端与移动端共用方法
 * public目录下文件不能import除此目录外任何文件，不能引入ecCom、antd组件，修改public目录需注意兼容PC端、移动端
 * 方法内部可能存在数据源、函数体等在两种终端逻辑不一致情况，统一通过此类过渡,不同终端先set进来，public方法内import此文件调用，达到两种终端适配
 */

const src = {
    isMobile: false,
    globalStore: {},
    layoutStore: {},
    FieldEntity: null,
    API_REQ: null,
    getLabel: null,
    setIsMobile: function(flag){
        this.isMobile = flag;
    },
    init: function(globalStore, layoutStore, FieldEntity, API_REQ, getLabel){
        this.globalStore = globalStore;
        this.layoutStore = layoutStore;
        this.FieldEntity = FieldEntity;
        this.API_REQ = API_REQ;
        this.getLabel = getLabel;
    }
}

export default src;


// WEBPACK FOOTER //
// ../src4js/pc4mobx/workflowForm/util/public/source.js